import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Certificate from "../../../components/Modals/StudentFlow/CoachDetails/Certificate/Certificate";
import CoachAvailibility from "../../../components/Modals/StudentFlow/CoachDetails/CoachAvailibility/CoachAvailibility";
import {
  BTCALogo,
  InfoIconGray,
  LTALogo,
  messageIconBlack,
  NATIONALLogo,
} from "../../../constant/imagePath";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { BookALessonCardWithGalleryMobile } from "../../../stories/BookALessonWithGalleryMobile/BookALessonWithGalleryMobile";
import { Button } from "../../../stories/Button/Button";
import { Checkbox } from "../../../stories/Checkbox/Checkbox";
import { CoachDetailAboutMe } from "../../../stories/CoachDetailAboutMe/CoachDetailAboutMe";
import { CoachDetailsCertificates } from "../../../stories/CoachDetailCertificates/CoachDetailsCertificates";
import { CoachDetailsTestimonialsAndRatings } from "../../../stories/CoachDetailsTestimonialsAndRatings/CoachDetailsTestimonialsAndRatings";
import { CoachDetailsTrainingLocations } from "../../../stories/CoachDetailTrainingLocations/CoachDetailsTrainingLocations";
import { CommonQuestions } from "../../../stories/CommonQuestions/CommonQuestions";
import { LinkButtonWithIcon } from "../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter";
import { ReviewBox } from "../../../stories/ReviewBox/ReviewBox";
import { Reviews } from "../../../stories/Reviews/Reviews";
import { ReviewsOnSidebar } from "../../../stories/ReviewsOnSidebar/ReviewsOnSidebar";
import { WhatOurStudentSay } from "../../../stories/WhatOurStudentSay/WhatOurStudentSay";
import ReviewsMobile from "../../CoachFlow/Reviews/ReviewMobile";
import classes from "./CoachDetailMobile.module.css";

export default function CoachDetailMobile() {
  const [confirmProfile, setConfirmProfile] = useState([]);
  const [isCongrats, setIsCongrats] = useState(false);
  const history = useHistory();
  const [showCertificate, setShowCertificate] = useState(false);
  const [checkAvailibility, setCheckAvailibility] = useState(false);

  const [certificateData, setCerificateData] = useState([
    {
      logo: BTCALogo,
      description: "The British Tennis Coaches Association",
      onClick: () => setShowCertificate(true),
    },
    {
      logo: LTALogo,
      description: "LTA Tennis Coaching Qualification",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
  ]);
  const credsAndExpData = [
    {
      heading: "Extensive coaching experience",
      description:
        "John was the former coach of University of San Diego (’78—’96), and has coached over 25,000 students in the past 50 years",
    },
    {
      heading: "Industry recognition",
      description:
        "John is a Four-time San Diego USPTA Coach-of-the-Year, inditeed to the USD Athletic Hall of Fame (2001), and his camp is awarded Tennis Magazine's Top-25 Adult Tennis Camps in 2006",
    },
    {
      heading: "Trusted by Students",
      description:
        "Some of John’s students include Jane Smith (10th in NA) and Sam Wang (8th in NA)",
    },
    {
      heading: "Speicalized in Forehand and backhand",
      description:
        "Consectetur adipiscing elit. Neque pharetra tempor turpis ut quis risus.",
    },
  ];
  const sessionPlanData = {
    description:
      "Every session is based on the athlete's skill level and prior knowledge of the sport. If my student needs to work on improving a specific move or drill for a team or their own personal aspirations, I am always open to working through it.",
    lists: [
      "Footwork",
      "Proper serve",
      "Balance and reflex response",
      "Fore-hand and back-hand drills",
      "Hustle Drills",
      " Playing at the Net",
      "Doubleheader Match - 15 minutes",
    ],
  };

  return (
    <>
      <div className={classes.coachDetail}>
        <section className={classes.videoSection}>
          <BookALessonCardWithGalleryMobile />
        </section>
        <section className={classes.mainContent}>
          <Container fluid className="p-0">
            <Row className="g-0">
              <Col sm={12} className={classes.mb24}>
                <CoachDetailAboutMe />
              </Col>
              <Col sm={12}>
                <CommonQuestions
                  data={[
                    {
                      title: "Credentials and Experience",
                      description: (
                        <div className={classes.credentialsAndExperience}>
                          <ul>
                            {credsAndExpData?.map((item) => {
                              return (
                                <li>
                                  <h6
                                    style={{
                                      ...Fonts.b2,
                                      fontFamily: "inter-600",
                                      color: Colors.neutralShadesOfNero,
                                      lineHeight: "24px",
                                    }}
                                  >
                                    {item?.heading}
                                  </h6>
                                  <p
                                    style={{
                                      ...Fonts.b1Mobile,
                                      color: Colors.neutralShadesOfDimGray,
                                    }}
                                  >
                                    {item?.description}
                                  </p>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ),
                    },
                    {
                      title: "Session plan",
                      description: (
                        <div className={classes.sessionPlan}>
                          <p
                            style={{
                              ...Fonts.b1Mobile,
                              color: Colors.neutralShadesOfDimGray,
                            }}
                          >
                            {sessionPlanData?.description}
                          </p>
                          <ul>
                            {sessionPlanData?.lists?.map((item) => {
                              return (
                                <li
                                  style={{
                                    ...Fonts.b1Mobile,
                                    color: Colors.neutralShadesOfDimGray,
                                  }}
                                >
                                  {item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ),
                    },
                  ]}
                />
              </Col>
              <Col sm={12} className={`${[classes.mt48].join(" ")}`}>
                <CoachDetailsCertificates data={certificateData} />
              </Col>
              <Col sm={12} className={`${[classes.mt48].join(" ")}`}>
                <CoachDetailsTrainingLocations />
              </Col>

              <Col sm={12} className={`${[classes.mt48].join(" ")}`}>
                <CommonQuestions heading="Common Questions" />
              </Col>
              <Col sm={12} className={`${[classes.mt48].join(" ")}`}>
                <WhatOurStudentSay
                  showArrows={false}
                  headerStyle={{
                    ...Fonts.h2,
                    fontSize: "26px",
                    lineHeight: "32px",
                  }}
                />
              </Col>
              <Col
                sm={12}
                className={`${[classes.mt48].join(" ")}`}
                style={{
                  borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                }}
              >
                <CoachDetailsTestimonialsAndRatings heading={"Testimonials"} />
              </Col>
              <Col sm={12} className={`${[classes.mt48].join(" ")}`}>
                <ReviewBox />
              </Col>
              <Col sm={12} className={classes.mt32}>
                <Button
                  label={"show more"}
                  primary={false}
                  size={"Large"}
                  customStyle={{ padding: "12px 32px 12px 32px" }}
                  onClick={() => setIsCongrats(true)}
                />
              </Col>
            </Row>
          </Container>
        </section>
        {/* Footer */}
        <section className={classes.mt64}>
          <MobileFooter />
        </section>

        {showCertificate && (
          <Certificate show={showCertificate} setShow={setShowCertificate} />
        )}

        {checkAvailibility && (
          <CoachAvailibility
            show={checkAvailibility}
            setShow={setCheckAvailibility}
          />
        )}
      </div>
      <div
        className={[classes.bottomFixedDiv]}
        style={{
          borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          background: Colors.white,
        }}
      >
        <div>
          <p style={{ color: Colors.neutralShadesOfNero, ...Fonts.h6 }}>
            $75 / hr
          </p>
          <p
            style={{
              color: Colors.neutralShadesOfDimGray,
              ...Fonts.b2,
              lineHeight: "20px",
            }}
          >
            per person
          </p>
        </div>
        <div className={[classes.bottomFixedBtnDiv]}>
          <Button
            customStyle={{
              marginRight: 10,
            }}
            icon={messageIconBlack}
          />
          <Button
            customStyle={{
              width: "160px",
            }}
            primary={true}
            label={"Book a lesson"}
            onClick={() => setCheckAvailibility(true)}
          />
        </div>
      </div>
    </>
  );
}
